import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { IconComponent } from '../../../shared/components/icons/icon/icon.component';
import { TooltipComponent } from '../../../shared/components/tooltip/tooltip.component';
import { ALERT_SEVERITY, AlertSeverity } from '../../models/Alert';

@Component({
    selector: 'app-alert-severity',
    imports: [IconComponent, TooltipComponent, TranslatePipe],
    templateUrl: './alert-severity.component.html',
    styleUrl: './alert-severity.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertSeverityComponent {
    readonly severity = input.required<AlertSeverity>();
    readonly size = input(24);
    readonly showDescription = input(false);
    readonly showTooltip = input(true);
    readonly ariaLabel = input<string>();
    protected readonly tooltipDisabled = computed(() => !this.showTooltip() || this.showDescription());

    protected readonly iconPath = computed(() => {
        const pathPrefix = '/assets/img/';
        if (this.severity() === ALERT_SEVERITY.HIGH) {
            return pathPrefix.concat('high-alert.svg');
        }

        if (this.severity() === ALERT_SEVERITY.NORMAL) {
            return pathPrefix.concat('warning-alert.svg');
        }
    });

    protected readonly alertSeverityKey = computed(() => {
        return `ALERT_SEVERITY_${this.severity()}`;
    });
}
